module.exports = __webpack_public_path__ + "static/media/layer-group.8f2493cb.svg";